import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    Input,
    Type,
    computed,
    signal,
    Signal,
    inject,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IPreviewContext } from './services/content-preview.service';

@Component({
    selector: 'telxl-shared-content-preview-modal',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
    templateUrl: './content-preview-modal.component.html',
    styleUrl: './content-preview-modal.component.scss',
})
export class TelXLContentPreviewModalComponent {
    readonly #activeModal = inject(NgbActiveModal);

    @Input({ required: true }) set context(v: IPreviewContext) {
        this.#context.set(v);
    }
    @Input({ required: true }) set component(v: Type<any>) {
        this.#component.set(v);
    }

    readonly #context = signal<IPreviewContext | null>(null);
    readonly #component = signal<Type<any> | null>(null);

    ctx: Signal<IPreviewContext> = computed(() => {
        const ctx = this.#context();
        if (!ctx) throw new Error('PreviewContext not set');
        return ctx;
    });

    comp = computed(() => this.#component());

    close() {
        this.#activeModal.dismiss();
    }
}
